/**
 * This class acts like an interface for scanner events
 */
export default class ScannerEvent {
    static MatchesType(type) {
        throw new Error(
            `MatchesType method is not implemented, called with type ${type}`
        );
    }

    static ParseData(jsonData) {
        throw new Error(
            `ParseData method is not implemented, called with JSON data: ${jsonData}`
        );
    }
}
